import { SiteStyleState } from 'js/lib/stores'

import getThemeConstants from './helpers/getThemeConstants'
import mergeDeepObjects from './helpers/mergeDeepObjects'

// Fix typecheck errors on type 'DefaultTheme'
type MyTheme = ReturnType<typeof getTheme>
declare module 'styled-components' {
    interface DefaultTheme extends MyTheme {}
}

export default function getTheme(
    currentTheme: any,
    theme?: string,
    siteStyle?: SiteStyleState,
) {
    const baseValues = currentTheme
        ? JSON.parse(JSON.stringify(currentTheme)) // Deep copy object
        : {}

    const themeValues = getThemeConstants(theme, siteStyle)

    const mergedValues = mergeDeepObjects(baseValues, themeValues)

    return mergedValues
}
